import * as React from 'react';

class ActionButton extends React.Component {
  //isList: Array<BPModel>;
  constructor() {
    super();
    this.state = {
      mouseOver: false,
      mouseDown: false,
    };
  }

  render() {
    return (
      <button
        className='btn float-start'
        style={{
          marginTop: '6px',
          marginBottom: '6px',
          position: 'relative',
          marginLeft: '6px',
          backgroundColor: this.props.isDisabled
            ? '#bbb'
            : this.props.iconColor,

          color: this.props.forground === undefined
            ? '#FFF'
            : this.props.forground,
        }}
        title={this.props.toolTip}
        disabled={this.props.isDisabled}
        onClick={this.props.onClick}
      >

        {this.props.label !== undefined &&
          <span style={{ paddingRight: '10px' }}>
            {this.props.label}
          </span>
        }

        {/*<i icon={solid(this.props.iconClass)} />*/}
        {this.props.iconClass === 'thumbs-up' && !this.props.waiting && (
          <i className='fa-solid fa-thumbs-up' />
        )}
        {this.props.iconClass === 'thumbs-down' && !this.props.waiting && (
          <i className='fa-solid fa-thumbs-down' />
        )}
        {this.props.waiting && <i className='fa-solid fa-spinner' spin />}
        {this.props.iconClass === 'save' && (
          <i className='fa-regular fa-save' />
        )}
        {this.props.iconClass === 'saving' && (
          <i
            style={{ color: '#000' }}
            className='fa-solid fa-spinner'
            spin
          />
        )}
        {this.props.iconClass === 'arrow-left' && (
          <i className='fa-solid fa-arrow-left' />
        )}
        {this.props.iconClass === 'arrow-right' && (
          <i className='fa-solid fa-arrow-right' />
        )}
        {this.props.iconClass === 'paperclip' && (
          <i className='fa-solid fa-paperclip' />
        )}
        {this.props.iconClass === 'trash-alt' && (
          <i className='fa-solid fa-trash-alt' />
        )}
        {this.props.iconClass === 'pdf' && (
          <i className='fa-regular fa-file-pdf' />
        )}
        {this.props.iconClass === 'file' && (
          <i className='fa-solid fa-file-image' />
        )}
        {this.props.iconClass === 'undo' && (
          <i className='fa-solid fa-undo' />
        )}
         {this.props.iconClass === 'play' && (
          <i className='fa-solid fa-play' />
        )}
        {this.props.iconClass === 'link' && (
          <i className='fa-solid fa-link' />
        )}
        {this.props.iconClass === 'person-running' && (
          <i className='fa-solid fa-person-running' />
        )}
        {this.props.iconClass === 'stamp' && (
          <i className='fa-solid fa-stamp' />
        )}{' '}
        {this.props.showBadge && (
          <span className='badge rounded-pill bg-secondary'>
            {this.props.badgeValue}
          </span>
        )}
      </button>
    );
  }
}

export default ActionButton;
